import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'
import Service6 from '../../components/Service6';

const Mentorship =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <PageTitle pageTitle={'Mentorship'} pagesub={'Mentorship'}/>
            <Service6/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default Mentorship;

